<template lang="pug">
  #app
    WorldMap
</template>

<script>
import WorldMap from './components/WorldMap.vue'

export default {
  name: 'app',
  components: {
    WorldMap
  }
}
</script>

<style lang="stylus">
@import './assets/styles/reset.styl'
@import './assets/styles/fonts.styl'
@import './assets/styles/mapbox-gl-draw.css'
@import './assets/styles/mapbox-gl.css'

body, html
  color rgba(#ffffff, 0.5)
  font-family: 'ISO v0.6'
  font-size 12px
  line-height 1.3em



</style>
